import { createAction, props } from '@ngrx/store';
import { User } from '@/app/shared/interfaces';
import { LoginRequestDto, ChallengeDto } from '@qc/shared/dto';

export const login = createAction('[Auth] Login', props<{ credentials: LoginRequestDto }>());
export const loginSuccess = createAction(
    '[Auth] Login Success',
    props<{
        accessToken?: string | null;
        refreshToken?: string | null;
        authChallengeToken?: string | null;
        challenge?: ChallengeDto;
        rememberMe?: boolean;
    }>(),
);
export const loginFailure = createAction('[Auth] Login Failure', props<{ error: string }>());
export const appLoaded = createAction('[Auth] App loaded');
export const initiateMfaSetup = createAction(
    '[Auth] Initiate MFA Setup',
    props<{ mfaType: string; identifier?: string }>(),
);
export const initiateMfaSetupSuccess = createAction(
    '[Auth] Initiate MFA Setup Success',
    props<{
        authChallengeToken: string;
        challenge: any;
        otpAuthUri?: string;
        secretKey?: string;
    }>(),
);

export const initiateMfaSetupFailure = createAction('[Auth] Initiate MFA Setup Failure', props<{ error: string }>());
export const verifyMfaCode = createAction('[Auth] Verify MFA Code', props<{ code: string }>());
export const verifyMfaCodeSuccess = createAction(
    '[Auth] Verify MFA Code Success',
    props<{
        authChallengeToken: string;
        challenge?: ChallengeDto;
    }>(),
);
export const verifyMfaCodeFailure = createAction('[Auth] Verify MFA Code Failure', props<{ error: string }>());
export const verifyDevice = createAction('[Auth] Verify Device', props<{ code: string }>());
export const verifyDeviceSuccess = createAction(
    '[Auth] Verify Device Success',
    props<{
        authChallengeToken: string;
        challenge?: ChallengeDto;
    }>(),
);
export const verifyDeviceFailure = createAction('[Auth] Verify Device Failure', props<{ error: string }>());
export const completeLogin = createAction('[Auth] Complete Login');
export const completeLoginSuccess = createAction(
    '[Auth] Complete Login Success',
    props<{
        accessToken?: string | null;
        refreshToken?: string | null;
        authChallengeToken?: string | null;
        challenge?: ChallengeDto;
    }>(),
);
export const completeLoginFailure = createAction('[Auth] Complete Login Failure', props<{ error: string }>());
export const loadUserProfile = createAction('[Auth] Load User Profile');
export const loadUserProfileSuccess = createAction('[Auth] Load User Profile Success', props<{ user: User }>());
export const loadUserProfileFailure = createAction('[Auth] Load User Profile Failure', props<{ error: string }>());
export const refreshToken = createAction('[Auth] Refresh Token');
export const refreshTokenSuccess = createAction(
    '[Auth] Refresh Token Success',
    props<{
        accessToken?: string | null;
        refreshToken?: string | null;
        authChallengeToken?: string | null;
        challenge?: ChallengeDto;
    }>(),
);
export const refreshTokenFailure = createAction('[Auth] Refresh Token Failure', props<{ error: string }>());
export const logout = createAction('[Auth] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');
export const logoutFailure = createAction('[Auth] Logout Failure', props<{ error: string }>());
export const clearChallenge = createAction('[Auth] Clear Challenge');
export const initAuthFromStorage = createAction('[Auth] Initialize Auth from Storage');
export const restoreChallengeState = createAction(
    '[Auth] Restore Challenge State',
    props<{
        authChallengeToken: string;
        challenge: ChallengeDto;
    }>(),
);
export const changeMfaMethod = createAction('[Auth] Change MFA Method', props<{ mfaMethodId: string }>());
export const changeMfaMethodSuccess = createAction(
    '[Auth] Change MFA Method Success',
    props<{
        authChallengeToken: string;
        challenge?: ChallengeDto;
    }>(),
);
export const changeMfaMethodFailure = createAction('[Auth] Change MFA Method Failure', props<{ error: string }>());
export const clearError = createAction('[AUTH] Clear error');
export const changePassword = createAction(
    '[Auth] Change Password',
    props<{ newPassword: string; confirmPassword: string }>(),
);
export const changePasswordSuccess = createAction(
    '[Auth] Change Password Success',
    props<{
        authChallengeToken: string | null;
        challenge?: ChallengeDto;
    }>(),
);
export const changePasswordFailure = createAction('[Auth] Change Password Failure', props<{ error: string }>());
export const skipPasswordChange = createAction('[Auth] Skip Password Change');
export const updateAuthChallengeToken = createAction(
    '[Auth] Update Auth Challenge Token',
    props<{ authChallengeToken: string }>(),
);

export const initiateChallengeVerification = createAction(
    '[Auth] Initiate Challenge Verification',
    props<{
        authChallengeToken: string;
        challenge?: ChallengeDto;
    }>(),
);

export const resendOtp = createAction('[Auth] Resend OTP');
export const resendOtpSuccess = createAction(
    '[Auth] Resend OTP Success',
    props<{
        authChallengeToken: string;
        challenge?: ChallengeDto;
    }>(),
);
export const resendOtpFailure = createAction('[Auth] Resend OTP Failure', props<{ error: string }>());
